import React, { Component } from 'react';
import { BrowserRouter/*, Switch, Route */} from 'react-router-dom';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { library } from '@fortawesome/fontawesome-svg-core'; //svg core

// IMPORTS
//Components, Containers, Views
import View404 from '../Views/404';
import Homepage from '../Views/homepage';
import Adminpage from '../Views/admin/adminpage';
import Programpage from '../Views/programpage';
import Documentpage from '../Components/Modules/Document/documentview';
import ContactPage from '../Components/Modules/Contact/contactview';
import LoginPage from '../Views/loginView';
import Header from '../Containers/header';
import Footer from '../Containers/footer';
import ScrollTop from '../Components/ScrollTop';


// Icons LIBRARY (only those icons can be used, to add new fontawesome icons add fa[ICONNAME] on both line separated by coma)
import {faMinus,faBullhorn,faDownload,faLink,faFolder,faFolderOpen,faFileAlt,faBox,faBoxOpen,faMinusSquare,faPlusSquare,faBan,faPlus,faSearch,faIndent,faTh,faDonate,faList,faBomb,faExclamationTriangle,faClipboardList,faAddressCard,faBars,faSortAmountDown,faSortAmountDownAlt,faSortAmountUp,faSignOutAlt,faChartPie,faTable,faTimes,faLock,faUser,faBell,faLightbulb,faCompressArrowsAlt,faMoon,faExpandArrowsAlt, faAngleDoubleRight, faAngleDoubleLeft,faQuestionCircle,faSkullCrossbones,faBug,faBook,faCheck,faCheckSquare, faCoffee, faGlobeEurope, faIdBadge, faFlag, faUniversity, faFileDownload, faListUl, faCog, faEllipsisV, faHome, faTrash, faTimesCircle, faPlusCircle, faMinusCircle, faEraser,faCaretLeft, faCaretRight, faPen, faCaretDown,faCaretUp, faHistory, faSpinner, faInfoCircle, faSyncAlt } from '@fortawesome/free-solid-svg-icons'; // solid Icons
library.add(faMinus,  faBullhorn,faDownload,faLink,faFolder,faFolderOpen,faFileAlt,faBox,faBoxOpen,faMinusSquare,faPlusSquare,faBan,faPlus,faSearch,faIndent,faTh,faDonate,faList,faBomb,faExclamationTriangle,faClipboardList,faAddressCard,faBars,faSortAmountDown,faSortAmountDownAlt,faSortAmountUp,faSignOutAlt,faChartPie,faTable,faTimes,faLock,faUser,faBell,faLightbulb,faCompressArrowsAlt,faMoon,faExpandArrowsAlt,faAngleDoubleRight,faAngleDoubleLeft,faQuestionCircle, faSkullCrossbones,faBug,faBook,faCheck,faCheckSquare,faCoffee, faGlobeEurope, faIdBadge,faPen, faFlag, faUniversity,faFileDownload,faCaretRight,faCaretLeft, faListUl,faCog, faEllipsisV, faHome,faTrash, faTimesCircle, faPlusCircle, faMinusCircle, faEraser, faCaretDown,faCaretUp, faHistory,faSpinner,faInfoCircle,faSyncAlt)



class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appStructure:[
        {
          name: "Homepage",
          isActive: true,
          isExpendable: false,
          children: [],
        },
        {
            name: "Dashboard",
            layout: "Classic",
            uri: "/",
            isActive: false,
            isExpendable: false,
            children: [],
        },
        {
            name: "Contacts",
            layout: "Classic",
            uri: "",
            isActive: false,
            isExpendable: false,
            children: [],
        },
        {
            name: "Programs",
            layout: "Classic",
            uri: "",
            isActive: false,
            isExpendable: false,
            children: [
                {
                    name: "Overview",
                    icon:"list",
                    uri: "",
                    isActive: false
                },
                {
                    name: "Risks",
                    icon:"exclamation-triangle",
                    uri: "",
                    isActive: false
                },
                {
                    name: "Prime and Deduct",
                    icon:"donate",
                    uri: "",
                    isActive: false
                },
                {
                    name: "Sinistres",
                    icon:"bomb",
                    uri: "",
                    isActive: false
                },
                {
                    name: "Statistics",
                    icon:"chart-pie",
                    uri: "",
                    isActive: false
                }
            ],
        },
        {
            name: "Documents",
            layout: "Classic",
            uri: "",
            isActive: false,
            isExpendable: false,
            children: [],
        },
        {
            name: "Internal Audit",
            layout: "Classic",
            uri: "",
            isActive: false,
            isExpendable: false,
            children: [],
        },
        {
            name: "Admin",
            layout: "Classic",
            uri: "",
            isActive: false,
            isExpendable: false,
            children:
                [
                    {
                        name: "Users",
                        icon:"user",
                        uri: "",
                        isActive: false
                    },
                    {
                        name: "Clients",
                        icon:"address-card",
                        uri: "",
                        isActive: false
                    },
                    {
                        name: "Counterparts",
                        icon:"clipboard-list",
                        uri: "",
                        isActive: false
                    },
                    {
                        name: "Parameters",
                        icon:"cog",
                        uri: "",
                        isActive: false
                    }
            ]
        },
      ],
      clients:["Client1","Client2","Client3"],
    }
  }
  //APP LOADED -- ONE TIME call or setup
  componentDidMount = ()=>{
    this.props.initAppStructure(this.state.appStructure);
    this.props.checkServerStatus(this.props);
    
    //this.props.loadClients(this.state.clients);

  }

  // MACRO DISPLAY VAR
  resolveClasses = ()=>{
    var classes = "App ";
    if(this.props.presentationMode){
      classes = classes+"slideShowMode ";
    }    
    if(this.props.nightMode){
      classes = classes+"darkMode ";
    }
    return classes
  }

  // SWITCH VIEW TO LOAD
  switchView = ()=>{
    
    if(this.props.user.arcs===0)
      return <LoginPage></LoginPage>;
    else{
      var appClasses = this.resolveClasses();
      var containerWrapper = this.createContainerContent();
      var container = this.props.isConnected ? <div className="Container">
        {
         containerWrapper 
        }
      </div> : null;
      return  <div className={appClasses}>
                <Header AppName="" LogoIcon="globe-europe"></Header>
                {container}
                <Footer></Footer>
              </div>
              
    }
  }
  // CHANGE IN GLOBAL STATE CHANGE THE LOADED VIEW
  // FOR URI REDIRECT  => 
  createContainerContent = ()=>{
    //var selectedItem = this.props.sidebarContent.filter((item,key)=>item.isActive === true)[0];
    
    switch (this.props.activeView) {
      case "Admin":
        return <Adminpage></Adminpage>;
      case "Programs":
        return <Programpage></Programpage>;
      case "Contacts":
        return <ContactPage></ContactPage>;
      case "Documents":
        return <Documentpage></Documentpage>;
      case "Homepage":
        return <Homepage></Homepage>;
      case "Dashboard":
          return <Homepage></Homepage>;
      default:
        return <View404></View404>;
    }
    
  }


  render() {
    var view = this.switchView();
    if(this.props.session !=null && this.props.user.fullName ===""){
      // TODO AUTO LOGGING
      // GET SESSION IN STORAGE

    }
        
    return (
      <BrowserRouter>
          {view}   
          <ScrollTop></ScrollTop> 
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    activeView : state.appReducer.activeView,
    presentationMode : state.appReducer.presentationMode,
    nightMode: state.appReducer.nightMode,
    isConnected: state.appReducer.isConnected,
    sidebarContent: state.appReducer.sidebarContent,
    user:state.globalReducer.user,
    session: state.apiReducer.session,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    checkServerStatus : (params,props) => dispatch(repositoryActions.checkServerStatus (params, props)),
    initAppStructure: (content) => dispatch(repositoryActions.initAppStructure(content)),
    loadClients: (content) => dispatch(repositoryActions.loadClients(content)),
    loginTry: (user) => dispatch(repositoryActions.loginTry(user)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(App);
